import { default as Step } from '@material-ui/core/Step'
import { default as StepLabel } from '@material-ui/core/StepLabel'
import { default as Mui4Stepper, Orientation, StepperProps as Mui4StepperProps } from '@material-ui/core/Stepper'
import { makeStyles } from '@material-ui/core/styles'
import ChevronRight from '@material-ui/icons/ChevronRight'
import { Theme } from '@mui/material'
import { ReactNode } from 'react'

const useStepperStyles = makeStyles<Theme, { orientation: Orientation }>({
  root: {
    padding: ({ orientation }) => (orientation === 'horizontal' ? '.5rem 0 1rem 0' : '24px'),

    '& .MuiButtonBase-root': {
      cursor: 'default',
    },
    '& .MuiStepIcon-root': {
      color: '#ECECED',
    },
    '& .MuiStepIcon-text': {
      fill: '#4F4D55',
    },
    '& .MuiStepIcon-root.MuiStepIcon-active': {
      color: '#1751D0',
    },
    '& .MuiStepLabel-active': {
      color: '#1751D0 !important',
    },
    '& .MuiStepIcon-active .MuiStepIcon-text': {
      fill: '#fff !important',
    },
    '& .MuiStepLabel-label': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiStepIcon-root.MuiStepIcon-completed': {
      color: '#1751D0',
    },
    '& .MuiStepLabel-completed': {
      color: '#1751D0 !important',
    },
    '& .MuiTypography-root': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
    '& .MuiStepLabel-label .MuiSvgIcon-root': {
      fontSize: '20px',
      margin: '0 10px',
    },
  },
})

export type StepType = {
  content: string | JSX.Element // Displayed text or component for the step (eg. Link or you can add some tooltip in your text)
  isComplete: boolean // Marks step as completed
  id: number // Used as key
  stepNumber?: number
}

export type OsStepperWithStepsProps = Omit<Mui4StepperProps, 'classes' | 'children'> & {
  steps: StepType[]
  children?: never
}

export type OsStepperWithChildrenProps = Omit<Mui4StepperProps, 'classes'> & {
  steps?: undefined
  children?: ReactNode
}

export type OsStepperProps = OsStepperWithStepsProps | OsStepperWithChildrenProps

export const Stepper = (props: OsStepperProps) => {
  const orientation = props.orientation || 'horizontal'
  const isStepsMode = Array.isArray((props as OsStepperWithStepsProps).steps)

  const stepperClasses = useStepperStyles({ orientation })

  if (isStepsMode) {
    const { steps, ...stepperProps } = props as OsStepperWithStepsProps
    return (
      <Mui4Stepper classes={stepperClasses} {...stepperProps}>
        {steps.map((step, index) => (
          <Step key={step.id} completed={step.isComplete}>
            <StepLabel
              {...(step.stepNumber !== undefined && {
                StepIconProps: { icon: step.stepNumber },
              })}
            >
              {step.content}
              {orientation === 'horizontal' && index !== steps.length - 1 && <ChevronRight />}
            </StepLabel>
          </Step>
        ))}
      </Mui4Stepper>
    )
  }

  const { children, ...stepperProps } = props as OsStepperWithChildrenProps
  return (
    <Mui4Stepper classes={stepperClasses} {...stepperProps}>
      {children}
    </Mui4Stepper>
  )
}
